export const navData = [
  {
    id: 0,
    title: "Features",
  },
  {
    id: 1,
    title: "Pricing",
  },
  {
    id: 2,
    title: "Resources",
  },
];
